import { Outlet } from 'react-router-dom';

import Navbar from '../components/Navbar/Navbar';
import AuthModule from '../view/authentication/AuthModule';
import Footer from '../components/Footer/Footer';
import ScrollToTop from '../utils/ScrollToTop';

export default function Layout() {
    return (
        <>
            {/* ScrollToTop will apply to all child routes */}
            <ScrollToTop />

            {/* Navbar will apply to all child routes */}
            <Navbar />

            {/* Outlet is where the nested routes are rendered */}
            <Outlet />
            <AuthModule />

            {/* Footer will apply to all child routes */}
            <Footer />
        </>
    );
}